import * as React from "react";
import { forwardRef } from "react";
const SvgCirclePlay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "glyphicons-camera", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "circle-play", fill: "currentColor", d: "M16,4A12,12,0,1,0,28,16,12.01343,12.01343,0,0,0,16,4Zm3.373,12.36914-4.59638,3.05347A.5.5,0,0,1,14,19.0061V12.89941a.5.5,0,0,1,.77667-.4165l4.59638,3.05334A.49992.49992,0,0,1,19.37305,16.36914Z" }));
const ForwardRef = forwardRef(SvgCirclePlay);
export default ForwardRef;
